export enum NotificationTypes {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}

export interface NotificationProps {
  type: NotificationTypes;
  message: string;
  /**
   * Auto-dismiss duration in ms. Omit to use the per-type default
   * (see DEFAULT_DURATIONS). A value of 0 makes the notification sticky.
   */
  duration?: number;
}

export interface Notification extends NotificationProps {
  id: string;
}

/**
 * Options accepted by the notify helpers (everything on the payload except the
 * message and type, which are passed positionally / by helper name).
 */
export interface NotifyOptions {
  duration?: number;
}

export interface NotificationListProps {
  notifications: Notification[];
}

export interface NotificationPortalProps extends NotificationListProps {
  modalElement: HTMLElement | null;
}
